import React, { useCallback } from "react";

const rectsMap = [
  { id: "1", x: 38, y: 0, transform: "" },
  { id: "2", x: 59.5, y: 4, transform: "rotate(30 59.5 4)" },
  { id: "3", x: 76.1865, y: 18, transform: "rotate(60 76.1865 18)" },

  { id: "4", x: 63, y: 46, transform: "rotate(-90 63 46)" },
  { id: "5", x: 58, y: 55.9282, transform: "rotate(-60 58 55.9282)" },
  { id: "6", x: 49, y: 62, transform: "rotate(-30 49 62)" },

  { id: "7", x: 38, y: 63, transform: "" },
  { id: "8", x: 28.5, y: 58, transform: "rotate(30 28.5 58)" },
  { id: "9", x: 22.1865, y: 49, transform: "rotate(60 22.1865 49)" },

  { id: "10", x: 0, y: 46, transform: "rotate(-90 0 46)" },
  { id: "11", x: 4, y: 24.9282, transform: "rotate(-60 4 24.9282)" },
  { id: "12", x: 18, y: 8, transform: "rotate(-30 18 8)" },
];

interface ISvgProps extends React.SVGProps<SVGSVGElement> {
  totalInstallments: number;
  paidInstallments: number;
  rectFill?: string;
}

const SmartInstallmentsStagesIcon = ({
  paidInstallments,
  totalInstallments,
  rectFill,
  ...props
}: ISvgProps) => {
  const getFillOpacity = useCallback(
    (index: number): string => {
      if (index >= totalInstallments) return "0.08";
      if (index >= paidInstallments) return "0.5";
      return "1";
    },
    [totalInstallments, paidInstallments],
  );

  return (
    <svg
      width="84"
      height="84"
      viewBox="0 0 84 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${props.className} smart-installments-stages-icon`}
      {...props}
    >
      {rectsMap.map((rect, index) => (
        <rect
          id={rect.id}
          key={index}
          x={rect.x}
          y={rect.y}
          width={8}
          height={21}
          rx={4}
          transform={rect.transform}
          fill={rectFill ? "currentColor" : "#FFFEFE"}
          fillOpacity={getFillOpacity(index)}
        />
      ))}
    </svg>
  );
};

export default SmartInstallmentsStagesIcon;
